// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  margin-bottom: 30px;
  box-shadow: var(--orwi-shadow);
  position: relative;
  font-family: "Inter";
  border-radius: 4px;
  width: 95vw;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.feed-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  font-size: 16px;
  font-weight: 500;
}

.title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  padding-bottom: 0px;
}

.title-text {
  font-size: 18px;
  font-weight: 500;
}

.feed-desc {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  margin: 10px;
  margin-top: 0px;
}

.property-wrapper {
  display: flex;
  justify-content: space-between;
  margin-right: 5px;
  margin-left: 5px;
  align-items: center;
}

@media screen and (min-width: 768px) {
  .card {
    margin: 10px;
    /* margin-bottom: 30px; */
    box-shadow: var(--orwi-shadow);
    position: relative;
    font-family: "Inter";
    width: 44vw;
    /* margin-right: 20px; */
    height: 400px;
  }
  .content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 165px;
  }
}
@media screen and (min-width: 1024px) {
  .card {
    margin: 10px;
    /* margin-bottom: 30px; */
    box-shadow: var(--orwi-shadow);
    position: relative;
    font-family: "Inter";
    width: 34vw;
    /* margin-right: 20px; */
    height: 400px;
  }
  .content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 165px;
  }
}
.content {
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 5px;
  padding-top: 0px;
  max-width: 65%;
}

.right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
}

.title {
  padding: 2px;
  font-size: 16px;
  font-weight: 500;
}

.bonus {
  padding: 2px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  font-family: "Inter";
}

.desc {
  font-size: 12px;
  padding: 2px;
}

.range {
  font-size: 14px;
  padding: 2px;
}

.active-image {
  opacity: 0.5;
  transform: translateX(30%);
}

.active-details {
  transform: perspective(2000px) rotateY(0deg);
}

.img1 {
  transition: 0.3s ease-in-out;
  -webkit-transition: 0.3s ease-in-out;
}

.card {
  font-size: 12px;
}

.details-item {
  font-size: 16px;
  color: var(--ion-color-primary);
  padding: 10px;
  font-weight: bold;
}

.details {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.card .image {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.card .image img {
  width: 100%;
  transition: 0.5s;
  max-height: 250px;
  object-fit: cover;
}

.card .details {
  position: absolute;
  top: 0;
  left: 0;
  width: 70%; /*100%*/
  height: 75%;
  background: white;
  transition: 0.5s;
  transform-origin: left;
  transform: perspective(2000px) rotateY(-90deg);
}

.card .details .center {
  padding: 20px;
  text-align: center;
  background: #fff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.card .details .center h1 {
  margin: 0;
  padding: 0;
  color: #ff3636;
  line-height: 20px;
  font-size: 20px;
  text-transform: uppercase;
}

.card .details .center h1 span {
  font-size: 14px;
  color: #262626;
}

.card .details .center p {
  margin: 10px 0;
  padding: 0;
  color: #262626;
}

.card .details .center ul {
  margin: 10px auto 0;
  padding: 0;
  display: table;
}

.card .details .center ul li {
  list-style: none;
  margin: 0 5px;
  float: left;
}

.card .details .center ul li a {
  display: block;
  background: #262626;
  color: #fff;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  transform: 0.5s;
}

.rating {
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
  font-size: 20px;
  background-color: red;
  margin: 10px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.golden-rating {
  display: inline-block;
  outline: none;
  font-family: inherit;
  font-size: 15px;
  box-sizing: border-box;
  border: none;
  border-radius: 0.3em;
  height: 2.75em;
  line-height: 2.5em;
  text-transform: uppercase;
  padding: 0 1em;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(110, 80, 20, 0.4), inset 0 -2px 5px 1px #8b4208, inset 0 -1px 1px 3px #fae385;
  background-image: linear-gradient(160deg, #a54e07, #b47e11, #fef1a2, #bc881b, #a54e07);
  border: 1px solid #a55d07;
  color: #783205;
  text-shadow: 0 2px 2px #fae385;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-size: 100% 100%;
  background-position: center;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  right: 20px;
  font-weight: bold;
}

.property-div {
  font-size: 20px;
  display: flex;
  justify-content: space-evenly;
  background-color: var(--ion-color-tertiary);
  color: #fff;
  border-radius: 4px;
  padding: 5px;
  padding-top: 9px;
  margin-bottom: 10px;
  padding-left: 14px;
}

.item-property {
  margin-right: 10px;
  font-size: 16px;
}

.property-disabled {
  filter: opacity(0.3);
}

.heart-filter {
  filter: initial !important;
}

.range-content {
  display: inline-block;
  outline: none;
  font-family: inherit;
  box-sizing: border-box;
  border: none;
  border-radius: 50px;
  line-height: 2.5em;
  text-transform: uppercase;
  color: #ffffff;
  background: #ffffff;
  cursor: pointer;
  background-size: 100% 100%;
  background-position: center;
  position: absolute;
  top: 20px;
  right: 20px;
  font-weight: bold;
  width: 30px;
  height: 30px;
  padding-top: 2px;
  padding-left: 1px;
}

.like-button {
  padding: 5px;
  padding-right: 0px;
  color: #bfbfbf;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  transition: all 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  filter: grayscale(100);
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.like-button.liked {
  color: #ff6e6f;
  border-color: currentColor;
  filter: grayscale(0);
}
.like-button:hover {
  border-color: currentColor;
}

.like-icon {
  width: 18px;
  height: 16px;
  display: inline-block;
  position: relative;
  margin-right: 0.25em;
  font-size: 1.5rem;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyMSAxOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuMTAxIDQuNDE3UzguODk1LjIwNyA1LjExMS4yMDdjLTQuNDY1IDAtMTAuOTY3IDYuODQ2IDUuMDgyIDE3LjU5MkMyNS4yMzcgNy4wMyAxOS42NjUuMjAyIDE1LjUwMS4yMDJjLTQuMTYyIDAtNS40IDQuMjE1LTUuNCA0LjIxNXoiIGZpbGw9IiNGRjZFNkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==") no-repeat center;
  background-size: 100%;
  animation: heartUnlike 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
}

.liked .like-icon {
  animation: heartPulse 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
}
.liked .like-icon [class^=heart-animation-] {
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyMSAxOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuMTAxIDQuNDE3UzguODk1LjIwNyA1LjExMS4yMDdjLTQuNDY1IDAtMTAuOTY3IDYuODQ2IDUuMDgyIDE3LjU5MkMyNS4yMzcgNy4wMyAxOS42NjUuMjAyIDE1LjUwMS4yMDJjLTQuMTYyIDAtNS40IDQuMjE1LTUuNCA0LjIxNXoiIGZpbGw9IiNGRjZFNkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==") no-repeat center;
  background-size: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 16px;
  height: 14px;
  opacity: 0;
}
.liked .like-icon [class^=heart-animation-]::before, .liked .like-icon [class^=heart-animation-]::after {
  content: "";
  background: inherit;
  background-size: 100%;
  width: inherit;
  height: inherit;
  display: inherit;
  position: relative;
  top: inherit;
  left: inherit;
  opacity: 0;
}
.liked .like-icon .heart-animation-1 {
  animation: heartFloatMain-1 1s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
}
.liked .like-icon .heart-animation-1::before, .liked .like-icon .heart-animation-1::after {
  width: 12px;
  height: 10px;
  visibility: hidden;
}
.liked .like-icon .heart-animation-1::before {
  opacity: 0.6;
  animation: heartFloatSub-1 1s 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
}
.liked .like-icon .heart-animation-1::after {
  animation: heartFloatSub-2 1s 0.15s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
  opacity: 0.75;
}
.liked .like-icon .heart-animation-2 {
  animation: heartFloatMain-2 1s 0.1s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
}
.liked .like-icon .heart-animation-2::before, .liked .like-icon .heart-animation-2::after {
  width: 10px;
  height: 8px;
  visibility: hidden;
}
.liked .like-icon .heart-animation-2::before {
  animation: heartFloatSub-3 1s 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
  opacity: 0.25;
}
.liked .like-icon .heart-animation-2::after {
  animation: heartFloatSub-4 1s 0.15s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
  opacity: 0.4;
}

@keyframes heartPulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}
@keyframes heartUnlike {
  50% {
    transform: scale(0.75);
  }
}
@keyframes heartFloatMain-1 {
  0% {
    opacity: 0;
    transform: translate(0) rotate(0);
  }
  50% {
    opacity: 1;
    transform: translate(0, -25px) rotate(-20deg);
  }
}
@keyframes heartFloatMain-2 {
  0% {
    opacity: 0;
    transform: translate(0) rotate(0) scale(0);
  }
  50% {
    opacity: 0.9;
    transform: translate(-10px, -38px) rotate(25deg) scale(1);
  }
}
@keyframes heartFloatSub-1 {
  0% {
    visibility: hidden;
    transform: translate(0) rotate(0);
  }
  50% {
    visibility: visible;
    transform: translate(13px, -13px) rotate(30deg);
  }
}
@keyframes heartFloatSub-2 {
  0% {
    visibility: hidden;
    transform: translate(0) rotate(0);
  }
  50% {
    visibility: visible;
    transform: translate(18px, -10px) rotate(55deg);
  }
}
@keyframes heartFloatSub-3 {
  0% {
    visibility: hidden;
    transform: translate(0) rotate(0);
  }
  50% {
    visibility: visible;
    transform: translate(-10px, -10px) rotate(-40deg);
  }
  100% {
    transform: translate(-50px, 0);
  }
}
@keyframes heartFloatSub-4 {
  0% {
    visibility: hidden;
    transform: translate(0) rotate(0);
  }
  50% {
    visibility: visible;
    transform: translate(2px, -18px) rotate(-25deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/home/feed-card/feed-card.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE;IACE,YAAA;IACA,yBAAA;IACA,8BAAA;IACA,kBAAA;IACA,oBAAA;IACA,WAAA;IACA,wBAAA;IACA,aAAA;EACF;EAEA;IACE,aAAA;IACA,sBAAA;IACA,8BAAA;IACA,aAAA;EAAF;AACF;AAGA;EACE;IACE,YAAA;IACA,yBAAA;IACA,8BAAA;IACA,kBAAA;IACA,oBAAA;IACA,WAAA;IACA,wBAAA;IACA,aAAA;EADF;EAIA;IACE,aAAA;IACA,sBAAA;IACA,8BAAA;IACA,aAAA;EAFF;AACF;AAKA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;AAHF;;AAMA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;AAHF;;AAMA;EACE,eAAA;EACA,YAAA;AAHF;;AAMA;EACE,eAAA;EACA,YAAA;AAHF;;AAMA;EACE,YAAA;EACA,0BAAA;AAHF;;AAMA;EACE,4CAAA;AAHF;;AAMA;EACE,4BAAA;EACA,oCAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAYA;EACE,eAAA;EACA,+BAAA;EACA,aAAA;EACA,iBAAA;AATF;;AAYA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AATF;;AAWA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AARF;;AAWA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA,EAAA,OAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,8CAAA;AARF;;AAWA;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AARF;;AAUA;EACE,SAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AAPF;;AASA;EACE,eAAA;EACA,cAAA;AANF;;AAQA;EACE,cAAA;EACA,UAAA;EACA,cAAA;AALF;;AAOA;EACE,mBAAA;EACA,UAAA;EACA,cAAA;AAJF;;AAMA;EACE,gBAAA;EACA,aAAA;EACA,WAAA;AAHF;;AAKA;EACE,cAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAFF;;AAKA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,aAAA;EACA,oBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,uIAAA;EAEA,sFAAA;EAQA,yBAAA;EACA,cAAA;EACA,8BAAA;EACA,eAAA;EACA,gCAAA;EACA,0BAAA;EACA,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;AAVF;;AAaA;EACE,eAAA;EACA,aAAA;EACA,6BAAA;EACA,2CAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAVF;;AAaA;EAEE,kBAAA;EACA,eAAA;AAXF;;AAcA;EACE,oBAAA;AAXF;;AAcA;EACE,0BAAA;AAXF;;AAgBA;EACE,qBAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;EACA,2BAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAbF;;AAqBA;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,6DAAA;EACA,sBAAA;EAEA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;AAnBF;AAqBE;EACE,cAnBG;EAoBH,0BAAA;EACA,oBAAA;AAnBJ;AAsBE;EACE,0BAAA;AApBJ;;AAyBA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,saAAA;EACA,qBAAA;EACA,yEAAA;AAtBF;;AAyBA;EACE,wEAAA;AAtBF;AAwBI;EACE,saAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAtBN;AAwBQ;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;AAtBV;AA0BI;EACE,2EAAA;AAxBN;AA0BM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAxBR;AA0BM;EACE,YAAA;EACA,gFAAA;AAxBR;AA0BM;EACE,gFAAA;EACA,aAAA;AAxBR;AA4BI;EACE,gFAAA;AA1BN;AA4BM;EACE,WAAA;EACA,WAAA;EACA,kBAAA;AA1BR;AA4BM;EACE,gFAAA;EACA,aAAA;AA1BR;AA4BM;EACE,gFAAA;EACA,YAAA;AA1BR;;AAiCA;EACE;IACE,mBAAA;EA9BF;EAgCA;IACE,qBAAA;EA9BF;AACF;AAiCA;EACE;IAAM,sBAAA;EA9BN;AACF;AAgCA;EACE;IACE,UAAA;IACA,iCAAA;EA9BF;EAgCA;IACE,UAAA;IACA,6CAAA;EA9BF;AACF;AAiCA;EACE;IACE,UAAA;IACA,0CAAA;EA/BF;EAiCA;IACE,YAAA;IACA,yDAAA;EA/BF;AACF;AAkCA;EACE;IACE,kBAAA;IACA,iCAAA;EAhCF;EAkCA;IACE,mBAAA;IACA,+CAAA;EAhCF;AACF;AAmCA;EACE;IACE,kBAAA;IACA,iCAAA;EAjCF;EAmCA;IACE,mBAAA;IACA,+CAAA;EAjCF;AACF;AAoCA;EACE;IACE,kBAAA;IACA,iCAAA;EAlCF;EAoCA;IACE,mBAAA;IACA,iDAAA;EAlCF;EAoCA;IACE,8BAAA;EAlCF;AACF;AAqCA;EACE;IACE,kBAAA;IACA,iCAAA;EAnCF;EAqCA;IACE,mBAAA;IACA,+CAAA;EAnCF;AACF","sourcesContent":[".card {\n  margin-bottom: 30px;\n  box-shadow: var(--orwi-shadow);\n  position: relative;\n  font-family: \"Inter\";\n  border-radius: 4px;\n  width: 95vw;\n}\n\n.content-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.feed-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.title-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  padding-bottom: 0px;\n}\n\n.title-text {\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.feed-desc {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  margin: 10px;\n  margin-top: 0px;\n}\n\n.property-wrapper {\n  display: flex;\n  justify-content: space-between;\n  margin-right: 5px;\n  margin-left: 5px;\n  align-items: center;\n}\n\n@media screen and (min-width: 768px) {\n  .card {\n    margin: 10px;\n    /* margin-bottom: 30px; */\n    box-shadow: var(--orwi-shadow);\n    position: relative;\n    font-family: \"Inter\";\n    width: 44vw;\n    /* margin-right: 20px; */\n    height: 400px;\n  }\n\n  .content-wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 165px;\n  }\n}\n\n@media screen and (min-width: 1024px) {\n  .card {\n    margin: 10px;\n    /* margin-bottom: 30px; */\n    box-shadow: var(--orwi-shadow);\n    position: relative;\n    font-family: \"Inter\";\n    width: 34vw;\n    /* margin-right: 20px; */\n    height: 400px;\n  }\n\n  .content-wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 165px;\n  }\n}\n\n.content {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  padding: 5px;\n  padding-top: 0px;\n  max-width: 65%;\n}\n\n.right {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  text-align: right;\n}\n\n.title {\n  padding: 2px;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.bonus {\n  padding: 2px;\n  font-size: 14px;\n  font-weight: 500;\n  display: flex;\n  font-family: \"Inter\";\n}\n\n.desc {\n  font-size: 12px;\n  padding: 2px;\n}\n\n.range {\n  font-size: 14px;\n  padding: 2px;\n}\n\n.active-image {\n  opacity: 0.5;\n  transform: translateX(30%);\n}\n\n.active-details {\n  transform: perspective(2000px) rotateY(0deg);\n}\n\n.img1 {\n  transition: 0.3s ease-in-out;\n  -webkit-transition: 0.3s ease-in-out;\n}\n\n.card {\n  font-size: 12px;\n  //position: absolute;\n  // top: 50%;\n  //left: 50%;\n  //transform: translate(-50%,-50%);\n  //width: 360px;\n  //height: 400px;\n}\n\n.details-item {\n  font-size: 16px;\n  color: var(--ion-color-primary);\n  padding: 10px;\n  font-weight: bold;\n}\n\n.details {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n\n.card .image {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n.card .image img {\n  width: 100%;\n  transition: 0.5s;\n  max-height: 250px;\n  object-fit: cover;\n}\n\n.card .details {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 70%; /*100%*/\n  height: 75%;\n  background: white;\n  transition: 0.5s;\n  transform-origin: left;\n  transform: perspective(2000px) rotateY(-90deg);\n}\n\n.card .details .center {\n  padding: 20px;\n  text-align: center;\n  background: #fff;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.card .details .center h1 {\n  margin: 0;\n  padding: 0;\n  color: #ff3636;\n  line-height: 20px;\n  font-size: 20px;\n  text-transform: uppercase;\n}\n.card .details .center h1 span {\n  font-size: 14px;\n  color: #262626;\n}\n.card .details .center p {\n  margin: 10px 0;\n  padding: 0;\n  color: #262626;\n}\n.card .details .center ul {\n  margin: 10px auto 0;\n  padding: 0;\n  display: table;\n}\n.card .details .center ul li {\n  list-style: none;\n  margin: 0 5px;\n  float: left;\n}\n.card .details .center ul li a {\n  display: block;\n  background: #262626;\n  color: #fff;\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  text-align: center;\n  transform: 0.5s;\n}\n\n.rating {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 10px;\n  font-size: 20px;\n  background-color: red;\n  margin: 10px;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.golden-rating {\n  display: inline-block;\n  outline: none;\n  font-family: inherit;\n  font-size: 15px;\n  box-sizing: border-box;\n  border: none;\n  border-radius: 0.3em;\n  height: 2.75em;\n  line-height: 2.5em;\n  text-transform: uppercase;\n  padding: 0 1em;\n  box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(110 80 20 / 40%),\n    inset 0 -2px 5px 1px #8b4208, inset 0 -1px 1px 3px #fae385;\n  background-image: linear-gradient(\n    160deg,\n    #a54e07,\n    #b47e11,\n    #fef1a2,\n    #bc881b,\n    #a54e07\n  );\n  border: 1px solid #a55d07;\n  color: #783205;\n  text-shadow: 0 2px 2px #fae385;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  background-size: 100% 100%;\n  background-position: center;\n  border-radius: 50%;\n  position: absolute;\n  top: 10px;\n  right: 20px;\n  font-weight: bold;\n}\n\n.property-div {\n  font-size: 20px;\n  display: flex;\n  justify-content: space-evenly;\n  background-color: var(--ion-color-tertiary);\n  color: #fff;\n  border-radius: 4px;\n  padding: 5px;\n  padding-top: 9px;\n  margin-bottom: 10px;\n  padding-left: 14px;\n}\n\n.item-property {\n  //margin-left: 5px;\n  margin-right: 10px;\n  font-size: 16px;\n}\n\n.property-disabled {\n  filter: opacity(0.3);\n}\n\n.heart-filter {\n  filter: initial!important;\n}\n\n// like animation\n\n.range-content{\n  display: inline-block;\n  outline: none;\n  font-family: inherit;\n  box-sizing: border-box;\n  border: none;\n  border-radius: 50px;  \n  line-height: 2.5em;\n  text-transform: uppercase; \n  color: #ffffff;  \n  background: #ffffff;;\n  cursor: pointer;\n  background-size: 100% 100%;\n  background-position: center;\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  font-weight: bold;\n  width: 30px;\n  height: 30px;\n  padding-top: 2px;\n  padding-left: 1px;\n}\n\n$gray: #ffffff;\n$pink: #ff6e6f;\n$bezier: cubic-bezier(.175, .885, .32, 1.275);\n\n\n.like-button { \n  padding: 5px;\n  padding-right: 0px;\n  color: darken($gray, 25%);\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  transition: all .25s $bezier;\n  filter:grayscale(100);\n  // filter: brightness(0) invert(1);\n  user-select: none;\n  \n  &.liked {\n    color: $pink;\n    border-color: currentColor;\n    filter: grayscale(0);\n  }\n  \n  &:hover {\n    border-color: currentColor;\n  }\n}\n\n\n.like-icon {\n  width: 18px;\n  height: 16px;\n  display: inline-block;\n  position: relative;\n  margin-right: .25em;\n  font-size: 1.5rem;\n  background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyMSAxOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuMTAxIDQuNDE3UzguODk1LjIwNyA1LjExMS4yMDdjLTQuNDY1IDAtMTAuOTY3IDYuODQ2IDUuMDgyIDE3LjU5MkMyNS4yMzcgNy4wMyAxOS42NjUuMjAyIDE1LjUwMS4yMDJjLTQuMTYyIDAtNS40IDQuMjE1LTUuNCA0LjIxNXoiIGZpbGw9IiNGRjZFNkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==') no-repeat center;\n  background-size: 100%;\n  animation: heartUnlike .25s $bezier both;\n}\n\n.liked .like-icon {\n  animation: heartPulse .25s $bezier both;\n  \n    [class^=\"heart-animation-\"] {\n      background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyMSAxOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuMTAxIDQuNDE3UzguODk1LjIwNyA1LjExMS4yMDdjLTQuNDY1IDAtMTAuOTY3IDYuODQ2IDUuMDgyIDE3LjU5MkMyNS4yMzcgNy4wMyAxOS42NjUuMjAyIDE1LjUwMS4yMDJjLTQuMTYyIDAtNS40IDQuMjE1LTUuNCA0LjIxNXoiIGZpbGw9IiNGRjZFNkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==') no-repeat center;\n      background-size: 100%;\n      display: block;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 16px;\n      height: 14px;\n      opacity: 0;\n\n        &::before, &::after {\n          content: '';\n          background: inherit;\n          background-size: 100%;\n          width: inherit;\n          height: inherit;\n          display: inherit;\n          position: relative;\n          top: inherit;\n          left: inherit;\n          opacity: 0;\n        }\n    }\n  \n    .heart-animation-1 {\n      animation: heartFloatMain-1 1s $bezier both;\n      \n      &::before, &::after {\n        width: 12px;\n        height: 10px;\n        visibility: hidden;\n      }\n      &::before {\n        opacity: .6;\n        animation: heartFloatSub-1 1s .25s $bezier both;\n      }\n      &::after {\n        animation: heartFloatSub-2 1s .15s $bezier both;\n        opacity: .75;\n      }\n    }\n\n    .heart-animation-2 {\n      animation: heartFloatMain-2 1s .1s $bezier both;\n      \n      &::before, &::after {\n        width: 10px;\n        height: 8px;\n        visibility: hidden;\n      }\n      &::before {\n        animation: heartFloatSub-3 1s .25s $bezier both;\n        opacity: .25;\n      }\n      &::after {\n        animation: heartFloatSub-4 1s .15s $bezier both;\n        opacity: .4;\n      }\n    }\n}\n\n\n// Animations\n@keyframes heartPulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.5);\n  }\n}\n\n@keyframes heartUnlike {\n  50% { transform: scale(.75) ; }\n}\n\n@keyframes heartFloatMain-1 {\n  0% { \n    opacity: 0; \n    transform: translate(0) rotate(0);\n  }\n  50% { \n    opacity: 1; \n    transform: translate(0, -25px) rotate(-20deg);\n  }\n}\n\n@keyframes heartFloatMain-2 {\n  0% { \n    opacity: 0; \n    transform: translate(0) rotate(0) scale(0);\n  }\n  50% { \n    opacity: .9; \n    transform: translate(-10px, -38px) rotate(25deg) scale(1);\n  }\n}\n\n@keyframes heartFloatSub-1 {\n  0% {\n    visibility: hidden;\n    transform: translate(0) rotate(0);\n  }\n  50% {\n    visibility: visible;\n    transform: translate(13px, -13px) rotate(30deg);\n  }\n}\n\n@keyframes heartFloatSub-2 {\n  0% {\n    visibility: hidden;\n    transform: translate(0) rotate(0);\n  }\n  50% {\n    visibility: visible;\n    transform: translate(18px, -10px) rotate(55deg);\n  }\n}\n\n@keyframes heartFloatSub-3 {\n  0% {\n    visibility: hidden;\n    transform: translate(0) rotate(0);\n  }\n  50% {\n    visibility: visible;\n    transform: translate(-10px, -10px) rotate(-40deg);\n  }\n  100% {\n    transform: translate(-50px, 0);\n  }\n}\n\n@keyframes heartFloatSub-4 {\n  0% {\n    visibility: hidden;\n    transform: translate(0) rotate(0);\n  }\n  50% {\n    visibility: visible;\n    transform: translate(2px, -18px) rotate(-25deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
